export const LEIPZIG_CENTER = [ 51.3396, 12.3712 ];
export const DEFAULT_ZOOM = 12;
export const CHECK_ZOOM = 16;
export const PHOTON_SEARCH_URL = "https://photon.komoot.io/api/";
export const DEFAULT_PHOTON_LANGUAGE = "en";
export const PHOTON_LIMIT = 5;
export const PHOTON_MIN_QUERY_LENGTH = 3;
export const PHOTON_RATE_LIMIT_STATUS = 429;
export const PHOTON_SUPPORTED_LANGUAGES = [ "de", "en", "fr", "it" ];
export const EUROPEAN_COUNTRY_CODES = [
    "AL", "AD", "AM", "AT", "AZ", "BY", "BE", "BA", "BG", "HR", "CY", "CZ",
    "DK", "EE", "FI", "FR", "GE", "DE", "GR", "HU", "IS", "IE", "IT", "XK",
    "LV", "LI", "LT", "LU", "MT", "MD", "MC", "ME", "NL", "MK", "NO", "PL",
    "PT", "RO", "RU", "SM", "RS", "SK", "SI", "ES", "SE", "CH", "TR", "UA",
    "GB", "VA",
];
